import store from '../store';
import windowActions from '../actions/windowActions';
import sessionServices from '../services/sessionServices';

const
{ RESIZE } = windowActions,
{ sessionTimer } = sessionServices;

export default {
    windowEventsHook: function() {
        window.onload = () => {
            resize();
            sessionTimer().run(60);
        };
        window.onresize = () => {
            resize();
        };
        window.onclick = () => {
            sessionTimer().restart();
        };
        window.onkeypress = () => {
            sessionTimer().restart();
        };
    }
}

function resize() {
    var p = 720, h = window.innerHeight, w = window.innerWidth, d;
    d = ((w < p && h > w) || (w > p && h > w) || (w < p && h < w)) ? "mobile" : "desktop";
    store.dispatch({ type: RESIZE, payload: { h: h, w: w, d: d } });
}
